import { BLACK, CapStyle, Color, EndCapStyle, LineStyle } from '.';

/**
 * Line appearance.
 */
export class LineAppearance {
  constructor(
    /** Cap style. */
    public caps: CapStyle = CapStyle.Butt,
    /** Color. */
    public color: Color = BLACK,
    /** Line style. */
    public style: LineStyle = LineStyle.Solid,
    /** Line thickness. */
    public thickness: number = 1,
    /** Style of the line ending. */
    public endCap?: EndCapStyle
  ) {}
}

/** Create LineAppearance using partial config object. */
export const createLineAppearance = (config: Partial<LineAppearance> = {}) =>
  new LineAppearance(
    config.caps,
    config.color,
    config.style,
    config.thickness,
    config.endCap
  );
